"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGRSLabeler = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
const MGRS_1 = require("../MGRS");
const UTM_1 = require("../utm/UTM");
const GridLabel_1 = require("./GridLabel");
const GridLabeler_1 = require("./GridLabeler");
const GridType_1 = require("./GridType");
/**
 * MGRS grid labeler
 */
class MGRSLabeler extends GridLabeler_1.GridLabeler {
    constructor(enabled, minZoom = 0, maxZoom, color, textSize, buffer) {
        super(enabled, minZoom, maxZoom, color, textSize, buffer);
    }
    /**
     * {@inheritDoc}
     */
    getLabels(gridType, zone, tileBounds) {
        let labels;
        if (tileBounds) {
            const drawBounds = zone.getDrawBounds(tileBounds, gridType);
            if (drawBounds) {
                labels = [];
                const precision = gridType;
                for (let easting = drawBounds.getMinLongitude(); easting <= drawBounds.getMaxLongitude(); easting += precision) {
                    for (let northing = drawBounds.getMinLatitude(); northing <= drawBounds.getMaxLatitude(); northing += precision) {
                        const label = this.getLabel(gridType, zone, easting, northing);
                        if (label) {
                            labels.push(label);
                        }
                    }
                }
            }
        }
        return labels;
    }
    /**
     * Get the grid zone label
     *
     * @param gridType
     *            grid type
     * @param easting
     *            easting
     * @param northing
     *            northing
     * @return labels
     */
    getLabel(gridType, zone, easting, northing) {
        let label;
        const precision = gridType;
        const bounds = zone.getBounds();
        const zoneNumber = zone.getNumber();
        const hemisphere = zone.getHemisphere();
        const northwest = UTM_1.UTM.point(zoneNumber, hemisphere, easting, northing + precision);
        const southwest = UTM_1.UTM.point(zoneNumber, hemisphere, easting, northing);
        const southeast = UTM_1.UTM.point(zoneNumber, hemisphere, easting + precision, northing);
        const northeast = UTM_1.UTM.point(zoneNumber, hemisphere, easting + precision, northing + precision);
        let minLatitude = Math.max(southwest.getLatitude(), southeast.getLatitude());
        minLatitude = Math.max(minLatitude, bounds.getMinLatitude());
        let maxLatitude = Math.min(northwest.getLatitude(), northeast.getLatitude());
        maxLatitude = Math.min(maxLatitude, bounds.getMaxLatitude());
        let minLongitude = Math.max(southwest.getLongitude(), northwest.getLongitude());
        minLongitude = Math.max(minLongitude, bounds.getMinLongitude());
        let maxLongitude = Math.min(southeast.getLongitude(), northeast.getLongitude());
        maxLongitude = Math.min(maxLongitude, bounds.getMaxLongitude());
        if (minLongitude <= maxLongitude && minLatitude <= maxLatitude) {
            const labelBounds = grid_js_1.Bounds.degrees(minLongitude, minLatitude, maxLongitude, maxLatitude);
            const center = labelBounds.getCentroid();
            const mgrs = MGRS_1.MGRS.from(center);
            let id;
            if (gridType === GridType_1.GridType.HUNDRED_KILOMETER) {
                id = mgrs.getColumnRowId();
            }
            else {
                id = mgrs.getEastingAndNorthing(gridType);
            }
            label = new GridLabel_1.GridLabel(id, center, labelBounds, gridType, mgrs);
        }
        return label;
    }
}
exports.MGRSLabeler = MGRSLabeler;
//# sourceMappingURL=MGRSLabeler.js.map